import { Link, Outlet, useOutletContext, useSearchParams } from 'react-router-dom';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import Checkbox from '@mui/material/Checkbox';
import {useVendorsListPagewise } from './hooks';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { RECORDS_PER_PAGE } from '../../config';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

//import { PopupAddVendor } from './popupAddVendor';
import LoaderFull from '../shared/loader-full-screen';
import { useDebouncedState } from '@mantine/hooks';
import { PAGE_SIZE_OPTIONS, decodeName, handleSearchKeys, handleSortUtil } from '../utils';
import { useGetLicenceStatus } from '../upload-docs/hooks';
const SORT_KEY_CONST = 'vendor_list_sort_key'
const SORT_ORDER_CONST = 'vendor_list_sort_order'
const PAGE_NO_CONST = 'vendor_list_page_no'
const CLIENT_ID = 'client_id'

function ListVendorsIndex() {
	const [searchParams, setSearchParams] = useSearchParams();
	const {getpageSizeCall, setpageSizeCall} = useOutletContext();

	const [DebounceSearch, setDebounceSearch] = useDebouncedState('', 500);
	

	const licence_check = useGetLicenceStatus()

	
	const [isValidLicence, setisValidLicence] = useState(false)


	//const [IsOpened, setIsOpened] = useState(false);

	const isFirstRender = useRef(true)
	
	
	const [Sort, setSort] = useState(handleSearchKeys(searchParams,SORT_KEY_CONST,SORT_ORDER_CONST,PAGE_NO_CONST,CLIENT_ID ));	
	
	const {hook: vendor_list_hook ,setArgs} = useVendorsListPagewise(Sort)


	function handleSort(typer) {
		let {sort_key ,sort_order} = handleSortUtil(typer , Sort)
		searchParams.set(SORT_KEY_CONST, sort_key)
		searchParams.set(SORT_ORDER_CONST, sort_order)
		setSearchParams(searchParams)

	}

	useEffect(() => {
		if (!isFirstRender.current) {
			let newSort = handleSearchKeys(searchParams, SORT_KEY_CONST, SORT_ORDER_CONST, PAGE_NO_CONST)
			setSort(newSort)
			setArgs((p) => {
				return {
					...p,
					...newSort
				}
			})
		}
		isFirstRender.current = false


	}, [searchParams, setArgs])


	const renderList = useCallback(() => {
		if (vendor_list_hook.isFetching) {
			return <LoaderFull />;
		} else if (vendor_list_hook.data?.data?.length === 0) {
			return <p className="text-center">No data found</p>;
		} else {
			return (
				<Outlet
					context={{
						vendorList: vendor_list_hook.data,
						Search: DebounceSearch,
						isValidLicence: isValidLicence
					}}
				/>
			);
		}
	}, [vendor_list_hook, DebounceSearch]);

	useEffect(() => {
        if (licence_check.fetchStatus === 'idle') {
            if (licence_check.status === 'success') {
                if ("valid" === licence_check?.data?.message) {
                    setisValidLicence(true)
                }
                else if (licence_check?.data?.status ===403){
                    setisValidLicence(false)
                }
               
            }
            else if (licence_check.status === 'error') {
                
            }
            
        }

    }, [licence_check.fetchStatus, licence_check.status, licence_check?.data])
	

	

		const [pageSize, setPageSize] = useState(null);
	
		useEffect(() => {
			// Define an async function inside useEffect
			const fetchPageSize = async () => {
			try {
				const page_size = await getpageSizeCall();
				console.log(page_size, "pg in client");
				setPageSize(page_size);  // Set the page size state
			} catch (error) {
				console.error("Error fetching page size:", error);
			}
			};
	
			fetchPageSize();  // Call the async function
	
		}, []);  //
		
		const handlePageSizeChange = async (event) => {
			const selectedPageSize = event.target.value;
			setPageSize(null)
			let ret = await setpageSizeCall(selectedPageSize)
			try {
				const page_size = await getpageSizeCall();
				console.log(page_size, "pg in client");
				setPageSize(page_size);  // Set the page size state
			} catch (error) {
				console.error("Error fetching page size:", error);
			}
	
		};
	
		useEffect(() => {
	
		  if (pageSize) { 
			searchParams.set(PAGE_NO_CONST, 1)
			setSearchParams(searchParams)
			setArgs(p=> {
				return { 
					...p,
					page: 1
				}
			})
			if (searchParams.get(PAGE_NO_CONST) ==1){
				vendor_list_hook.refetch()
			}
		  }
		}, [pageSize])
		
	

	return (
		<>
			<div className="grow h-screen overflow-x-hidden overflow-y-auto fontInter">
				{/* Right Side - White workspaces */}
				<>
					<div className="lg:flex gap-4 justify-between items-center vLBG py-4 px-6">
						<div>
							<h1 className="text-lg font-normal text-primary">
								List of <strong className="font-black">Vendors</strong>
							</h1>
							<p className="text-xs text-gray-500 mb-2">
								<Link
									to={`/my-clients?client_list_page_no=${searchParams.get('client_list_page_no')}&client_list_sort_key=${searchParams.get('client_list_sort_key')}&client_list_sort_order=${searchParams.get('client_list_sort_order')}`}
								>
									My Clients
								</Link>{' '}
								&nbsp; {'>'} &nbsp; Client -{' '}
								<span title={decodeName(searchParams.get('client_name'))}>
									{decodeName(searchParams.get('client_name'))}
								</span>
							</p>
						</div>
						<div className="flex gap-3 flex-wrap">
							<div className="flex gap-2">
								<div className="relative">
									<span className="material-icons absolute top-2 left-2 z-10 text-slate-400 text-md">
										search
									</span>
									<input
										type="text"
										onChange={(e) => {
											setDebounceSearch(() => {
												setArgs((p) => {
													return {
														...p,
														search: e.target.value,
														page: 1,
														sort: '',
													};
												});
												return e.target.value;
											});
										}}
										className="border relative border-slate-300 rounded-md w-full h-10 py-2 pr-2 pl-10 focus:outline-blue-400 text-sm"
										placeholder="Search..."
									/>
								</div>
							</div>
						</div>
					</div>
				</>

				<>
					<div className="p-6">
						<div className="listDHeight larger overflow-auto">
							<div className="flex venL gap-2 mb-2">
								<div className="flex-none w-[55px]">
									<div className="flex-none text-center relative w-[55px]">
										<span
											title="default sort"
											onClick={() => handleSort('')}
											className={`${Sort.type === '' ? 'text-primary' : 'cursor-pointer'}   material-icons w-4 text-sm mt-1`}
										>
											{' '}
											swap_vert
										</span>
									</div>
								</div>
								<div className="growS flex-none min-w-[900px] 2xl:grow 2xl:w-auto px-5 py-1 flex items-center justify-between text-xs">
									<div className="grow border-r pr-4 flex items-center ">
										<label
											onClick={() => handleSort('name')}
											className={`${Sort.type === 'name' ? 'text-primary' : ''} font-black block relative w-[120px] cursor-pointer`}
										>
											Name of Vendor
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[-2px]">
												swap_vert
											</span>
										</label>
									</div>
									<div className="flex-none px-4 text-center w-[140px]">
										<label
											onClick={() => handleSort('category_name')}
											className={`${Sort.type === 'category_name' ? 'text-primary' : ''} w-[100px] font-black block relative cursor-pointer`}
										>
											Expense Category
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[5px]">
												swap_vert
											</span>
										</label>
									</div>
									<div className="flex-none px-4 text-center w-[110px]">
										<label
											onClick={() => handleSort('human_annotation')}
											className={`${Sort.type === 'human_annotation' ? 'text-primary' : ''} w-[100px] font-black block relative cursor-pointer`}
										>
											Human Annotations
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[5px]">
												swap_vert
											</span>
										</label>
									</div>
									<div className="flex-none px-4 text-center w-[90px]">
										<label
											onClick={() => handleSort('total_invoices')}
											className={`${Sort.type === 'total_invoices' ? 'text-primary' : ''} font-black block relative cursor-pointer`}
										>
											Total Invoices
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[5px]">
												swap_vert
											</span>
										</label>
									</div>
									<div className="flex-none px-4 text-center w-[110px]">
										<label
											onClick={() => handleSort('total_contracts')}
											className={`${Sort.type === 'total_contracts' ? 'text-primary' : ''} font-black block relative cursor-pointer`}
										>
											Total Contracts
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[5px]">
												swap_vert
											</span>
										</label>
									</div>

									<div className="flex-none px-2 text-center w-[120px]">
										<label
											onClick={() => handleSort('percentage_complete')}
											className={`${Sort.type === 'percentage_complete' ? 'text-primary' : ''} font-black block relative cursor-pointer`}
										>
											% Processing Complete
											<span className="material-icons absolute w-4 top-0 right-0 text-sm ml-1 mt-[5px]">
												swap_vert
											</span>
										</label>
									</div>
								</div>
								<div className="flex-none w-[412px] pr-2">&nbsp;</div>
							</div>

							{renderList()}
						</div>
						<div className="flex justify-center gap-3 pt-2">
							{!vendor_list_hook.isLoading && (
								<>
								<div className="flex items-center justify-between space-x-4">
									{/* Pagination Component */}
									<div className="flex items-center space-x-2">
										{/* <p>Rows per page</p> */}
									{pageSize ? (
										<FormControl
											variant="outlined"
											size="small"
											sx={{
												minWidth: 120,
												'& .MuiOutlinedInput-root': {
												borderRadius: '0.375rem', // rounded-md
												backgroundColor: 'white',
												fontSize: '0.875rem', // text-sm
												},
												'& .MuiOutlinedInput-notchedOutline': {
												borderColor: '#D1D5DB', // border-gray-300
												},
												'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: '#60A5FA', // blue-400 on hover
												},
												'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: '#3B82F6', // focus:ring-blue-500
												borderWidth: '2px',
												},
											}}
											>
											<InputLabel id="page-size-label">Page Size</InputLabel>
											<Select
												labelId="page-size-label"
												value={pageSize || ''}
												onChange={handlePageSizeChange}
												label="Page Size"
											>
												{PAGE_SIZE_OPTIONS.map((size) => (
												<MenuItem key={size} value={size}>
													{size}
												</MenuItem>
												))}
											</Select>
											</FormControl>
									) : (
										<div className="w-[60px] h-[40px] flex justify-center items-center bg-gray-100 rounded-md text-sm text-center border border-gray-300">
										<span className="material-icons text-sm animate-spin">autorenew</span> {/* Spinner */}
										</div>
									)}
									</div>

										<Pagination
											page={Sort.page}
											onChange={(e, value) => {
												searchParams.set(PAGE_NO_CONST, value);
												setSearchParams(searchParams);
											}}
											count={Math.ceil(
												vendor_list_hook.data?.total_vendors / pageSize
											)}
											color="primary"
											variant="outlined"
											shape="rounded"
											className="w-full sm:w-auto"
										/>

									</div>
								</>
							)}
						</div>

						{/* {IsOpened && (
							<PopupAddVendor
								isOpened={IsOpened}
								setIsOpened={setIsOpened}
								vendor_list_hook={vendor_list_hook}
								client_id={searchParams.get('client_id')}
							/>
						)} */}
					</div>
				</>
			</div>
		</>
	);
}

export default ListVendorsIndex;
